import {Component, OnInit, ViewChild} from '@angular/core';
import {ApiClientService} from '../../../services/api-client.service';
import {UrlService} from '../../../services/url.service';
import {Amenity} from '../../../types/models';
import {AuthenticationService} from '../../../services/authentication.service';
import {AmenitiesService} from '../../../services/amenities.service';

declare const toastr: any;
declare const $: any;
declare const swal: any;

@Component({
    selector: 'amenities-info',
    templateUrl: './amenities-info.component.html',
    styleUrls: ['./amenities-info.component.scss']
})
export class AmenitiesInfoComponent implements OnInit {
    @ViewChild('form') form;
    data: Amenity = new Amenity();
    disabledSubmit = false;
    date: string = (new Date).toISOString();
    statusEditMode = false;
    noteEditMode = false;
    newNote = '';
    statusSelectDisabled = false;

    constructor(
        public api: ApiClientService,
        public amenitiesService: AmenitiesService,
        public authService: AuthenticationService,
        public urlService: UrlService
    ) {}

    ngOnInit() {
        if(this.amenitiesService.amenityInAmenityModal.status == 'approved')
            this.statusSelectDisabled = true;
        this.amenitiesService.amenityInAmenityModal.notes.sort((a: any, b: any) => {
            if (new Date(a.createdAt) < new Date(b.createdAt)) {
                return 1;
            } else if (new Date(a.createdAt) > new Date(b.createdAt)) {
                return -1;
            } else {
                return 0;
            }
        });
    }

    updateStatus(): void {
        const status = $('.status-view-edit select[name="status"]')[0] ? $('.status-view-edit select[name="status"]')[0].value : undefined;
        let transitionStatus = '';
        if(status == 'approved') {
            if(this.amenitiesService.amenityInAmenityModal.status == 'pending')
                transitionStatus = 'approved';
            if(this.amenitiesService.amenityInAmenityModal.status == 'declined')
                transitionStatus = 'declined_approved';
        } else if(status == 'pending') {
            if(this.amenitiesService.amenityInAmenityModal.status == 'approved')
                transitionStatus = 'approved_pending';
            if(this.amenitiesService.amenityInAmenityModal.status == 'declined')
                transitionStatus = 'declined_pending';
        } else if(status == 'declined') {
            if(this.amenitiesService.amenityInAmenityModal.status == 'approved')
                transitionStatus = 'approved_declined';
            if(this.amenitiesService.amenityInAmenityModal.status == 'pending')
                transitionStatus = 'declined';
        }

        this.disabledSubmit = true;
        const url = `/v1/booking/transit/${this.amenitiesService.amenityInAmenityModal.id}.json`;
        this.amenitiesService.api.patch('domainAmenities', url, {transition: transitionStatus}).subscribe(
            () => {
                this.disabledSubmit = false;
                this.updateView('Status was successfully updated');
            },
            error => {
                this.disabledSubmit = false;
                const body = JSON.parse(error._body);
                let errorMessage = 'Status update failed!';
                if(body && body.message) {
                    if(body.message === 'Not all required payments was paid!')
                        errorMessage = 'This booking cannot be approved until payments have been allocated and paid for';
                }
                this.api.errorHandler(error, errorMessage);
            }
        );
    }

    updateView(msg: string): void {
        toastr.success(msg);
        this.amenitiesService.getData();
        this.statusEditMode = false;
    }

    addNote(): void {
        if(this.newNote != '' &&  (this.newNote.replace(/&nbsp;/g, '')).replace(/\s/g, '') != '') {
            const url = `/v1/booking_notes.json`;
            const data = {booking: this.amenitiesService.amenityInAmenityModal.id, noteText: this.newNote};
            this.amenitiesService.api.post('domainAmenities', url, data).subscribe(
                res => {
                    toastr.success('Note was successfully created');
                    this.amenitiesService.amenityInAmenityModal.notes.unshift(res);
                    this.newNote = '';
                    this.amenitiesService.getData();
                    this.noteEditMode = false;
                },
                error => this.api.errorHandler(error, 'Note creation failed!')
            );
        } else
            toastr.warning('Note should not be blank');
    }

    turnEditMode(model, value) {
        if(!this.amenitiesService.amenityInAmenityModal.isCanEdit)
            return;
        if(model == 'status' && value) {
            if (this.isBookingDateLaterThanCurrent())
                return;
            if(this.statusSelectDisabled)
                return;
        }
        if(!this.amenitiesService.spinnerShow)
            this[model + 'EditMode'] = value;
    }

    isBookingDateLaterThanCurrent(): boolean {
        let flag = false;
        if(new Date(this.amenitiesService.amenityInAmenityModal.dateTo) <= new Date())
            flag = true;
        return flag;
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/amenities/amenity-info/amenities-info.component.ts